module.exports = __webpack_public_path__ + "static/img/35.2484a91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/35.jpg
// module id = YuEr
// module chunks = 1